/* eslint-disable no-template-curly-in-string */
import React, { Component, Fragment } from 'react';
import CelaneseAPI from '../../../services';
import config from '../../../config';
import InputField from '../../global/InputField';
import PlugwrapThickness from '../../PlugwrapThickness';
import TowItemSelectionForm from '../../../containers/TowItemSelectionForm';
import { Modal, Button, message, Switch, Tag, Radio, Alert } from 'antd';
import { Combobox } from 'react-widgets';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CustomLineGraph } from '../../custom-line-graph';
import { CapabilityGraphSmall } from '../../capability-graph-small';
import Convert from '../../../convert';
import Calculations from '../../../calculations';
import 'react-widgets/dist/css/react-widgets.css';
import './singleFilter.css';
import { getFiltersData } from './../../../actions/index';
import Translation from '../../../Translation';
import { utils } from '../../../config';

//import { timingSafeEqual } from 'crypto';

const initialState = {
    pref: {
        weight: ['g/100', 'mg', 'g'],
        lowpdlim: ['mm H₂O', 'pa'],
        lowpdCarbonlim: ['(mm H₂O/mm)', '(pa/mm)'],
        pz: ['% Dry Basis', '% Wet Basis'],
        pivmaxlim: ['Tow Weight', 'Wet Weight'],
        capsule: {
            0: {
                weight: '(mg/rod)',
                lowpdlim: ['(mm H₂O/rod)', '(pa/rod)']
            },
            1: {
                weight: '(mg/capsule)',
                lowpdlim: ['(mm H₂O/capsule)', '(pa/capsule)']
            }
        }
    },
    lines: [],
    finalTowItem: {},
    name: '',
    tipLength: 0,
    tipEpd: 0,
    tipsRod: 0,
    pzLevel: 0,
    cload: 0,
    tipCircumference: 0,
    rangeLength: 0,
    tipDiam: 0,
    cRangeLength: 0,
    towItem: null,
    plugwrapThickness: 0.039,
    tipPgWt: 0,
    newDpf: 0,
    newTd: 0,
    totalFilterLength: 120,
    totalFilterWeight: 80.47,
    totalFilterEPD: 400,
    whiteFilterWgt: 68.47,
    whiteFilterEPD: 370.9,
    towOnlyFilterWgt: 53.99,
    carbonOnlyFilterWgt: 0.00,
    carbonOnlyFilterEPD: 0.00,
    totalTipLength: 30,
    totalTipWeight: 20.12,
    totalTipEPD: 100,
    whiteTipWgt: 17.12,
    whiteTipEPD: 92.73,
    towOnlyTipWgt: 13.50,
    carbonOnlyTipWgt: 0.00,
    carbonOnlyTipEPD: 0.00,
    firmCured: '',
    intermediate: '',
    firmIntermedTime: '',
    firmnessIntermediate: 0,
    smoke: 71.16,
    tar: 63.9,
    nicotine: 47.19,
    eugenol: 0.00,
    time: 0.5,
    isTowRange: false,
    isCarbonRange: false,
    isKretek: false,
    isNewTowitem: false,
    isPlugwrapVisible: false,
    isTowItemSelectionVisible: false,
    isCload: false,
    carbonDisplay: 'displayNone',
    capsuleDisplay: 'displayNone',
    isEPDCarbon: false,
    loading: false,
    epdCarbon: 0,
    isIntermediate: true,
    showCalculateBlock: false,
    towItemLot: '',
    id: null,
    isRangeLength: false,
    isCRangeLength: false,
    isFetchingFilters: false,
    errorFilterChange: false,
    filterId: null,
    newCalculatedData: {},
    sharedByName: '',
    isCapsuleChecked: false,
    capsuleMode: "1",
    capsuleWt: 0,
    capsulePd: 0,
    capsuleNo: 0
}

/**
 * Class for single filter.
 *
 * @class SingleFilter
 * @extends {Component}
 */
class SingleFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            preferences: this.props.preferences,
            filterData: [],
            towItemProps: {},
            tipLength: this.props.toFilterTowItemData && this.props.toFilterTowItemData.tipRodLength ? this.props.toFilterTowItemData.tipRodLength : 0,
            tipsRod: this.props.toFilterTowItemData && this.props.toFilterTowItemData.tipsPerRod ? this.props.toFilterTowItemData.tipsPerRod : 0,
            tipEpd: this.props.toFilterTowItemData && this.props.toFilterTowItemData.tipEpd ? this.props.toFilterTowItemData.tipEpd : 0,
            pzLevel: this.props.toFilterTowItemData && this.props.toFilterTowItemData.pzLevel ? this.props.toFilterTowItemData.pzLevel : 0,
            cload: this.props.toFilterTowItemData && this.props.toFilterTowItemData.cload ? this.props.toFilterTowItemData.cload : 0,
            tipCircumference: this.props.toFilterTowItemData && this.props.toFilterTowItemData.tipCircumference ? this.props.toFilterTowItemData.tipCircumference : 0,
            rangeLength: this.props.toFilterTowItemData && this.props.toFilterTowItemData.rangeLength ? this.props.toFilterTowItemData.rangeLength : 0,
            tipDiam: this.props.toFilterTowItemData && this.props.toFilterTowItemData.tipDiam ? this.props.toFilterTowItemData.tipDiam : 0,
            isCarbonRange: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isCarbonRange ? this.props.toFilterTowItemData.isCarbonRange : 0,
            cRangeLength: this.props.toFilterTowItemData && this.props.toFilterTowItemData.cRangeLength ? this.props.toFilterTowItemData.cRangeLength : 0,
            plugwrapThickness: this.props.toFilterTowItemData && this.props.toFilterTowItemData.plugwrapThickness ? this.props.toFilterTowItemData.plugwrapThickness : 0.039,
            tipPgWt: this.props.toFilterTowItemData && this.props.toFilterTowItemData.tipPgWt ? this.props.toFilterTowItemData.tipPgWt : 0,
            newDpf: this.props.toFilterTowItemData && this.props.toFilterTowItemData.newDpf ? this.props.toFilterTowItemData.newDpf : 0,
            newTd: this.props.toFilterTowItemData && this.props.toFilterTowItemData.newTd ? this.props.toFilterTowItemData.newTd : 0,
            epdCarbon: this.props.toFilterTowItemData && this.props.toFilterTowItemData.epdCarbon ? this.props.toFilterTowItemData.epdCarbon : 0,
            isCload: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isCload ? this.props.toFilterTowItemData.isCload : false,
            isEPDCarbon: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isEPDCarbon ? this.props.toFilterTowItemData.isEPDCarbon : false,
            isNewTowitem: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isNewTowItemChecked ? this.props.toFilterTowItemData.isNewTowItemChecked : false,
            isPaperGlue: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isPaperGlue ? this.props.toFilterTowItemData.isPaperGlue : (this.props.isPaperGlueWt ? true : false),
            isTowRange: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isTowRange ? this.props.toFilterTowItemData.isTowRange : false,
            isCapsuleChecked: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isCapsule ? this.props.toFilterTowItemData.isCapsule : false,
            capsuleMode: this.props.toFilterTowItemData && this.props.toFilterTowItemData.capsuleMode ? this.props.toFilterTowItemData.capsuleMode : '1',
            capsuleWt: this.props.toFilterTowItemData && this.props.toFilterTowItemData.capsuleWt ? this.props.toFilterTowItemData.capsuleWt : 0,
            capsulePd: this.props.toFilterTowItemData && this.props.toFilterTowItemData.capsulePd ? this.props.toFilterTowItemData.capsulePd : 0,
            capsuleNo: this.props.toFilterTowItemData && this.props.toFilterTowItemData.capsuleNo ? this.props.toFilterTowItemData.capsuleNo : 0,
            capsuleDisplay: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isCapsule ? 'displayBlock' : 'displayNone',
            carbonDisplay: this.props.toFilterTowItemData && this.props.toFilterTowItemData.isCload ? 'displayBlock' : 'displayNone',
            towItem: {
                itemLot: this.props.toFilterTowItemVal || null,
            },
            towItemLot: this.props.toFilterTowItemVal || null,
            langSwitch: false // just to render the dynamic strings - will not be used anywhere else
        };

        this.towItemDelete = this.towItemDelete.bind(this);
        this.calculateUserRange = this.calculateUserRange.bind(this);
        this.handleCircChange = this.handleCircChange.bind(this);
        this.handleDiaChange = this.handleDiaChange.bind(this);
        this.toggleEPDCarbon = this.toggleEPDCarbon.bind(this);
    }
    componentWillReceiveProps(nextProps) {

        if (this.props.preferences !== nextProps.preferences) {
            this.setState({
                preferences: nextProps.preferences
            }, () => {
                this.handleFilter();
                this.setState({
                    isFetchingFilters: false
                });
            })
            if (this.state.preferences.language !== nextProps.preferences.language) {
                setTimeout(() => {
                    this.setState({
                        langSwitch: !this.state.langSwitch
                    });
                }, 1000);
            }
        }

        if (this.props.random !== nextProps.random) {
            this.calculateFilter();
        }

        if (this.props.saveRandomKey !== nextProps.saveRandomKey) {
            this.saveFilter();
        }

        if (this.props.saveFiltersData !== nextProps.saveFiltersData && this.props.saveFiltersId !== nextProps.saveFiltersId) {
            this.setState({
                name: nextProps.saveFiltersData,
                id: nextProps.saveFiltersId,
                errorFilterChange: true
            }, function () {
                this.handleFilter();
            });
            if (this.state.filterData) {
                let flag = true;
                let _this = this;
                this.state.filterData.forEach(function (val) {
                    if (val.id === nextProps.saveFiltersId) {
                        if (val.isShared) {
                            _this.setState({
                                sharedByName: ' (Shared by ' + val.sharedBy.firstName + ' ' + val.sharedBy.lastName + ')'
                            });
                            flag = false;
                            return;
                        } else {
                            flag = true;
                        }
                    }
                })
                if (flag) {
                    this.setState({
                        sharedByName: ''
                    });
                }
            }
        }
        if (this.state.filterData !== nextProps.filtersData && this.state.id === nextProps.saveFiltersId) {
            const matchedIndex = nextProps.filtersData.findIndex((val) => {
                return val.id === nextProps.saveFiltersId
            });
            if (matchedIndex === -1) {
                this.setState({
                    name: '',
                    id: null,
                    errorFilterChange: true
                }, function () {
                    this.handleFilter();
                });
            }
        }
        if (this.props.isPaperGlueWt !== nextProps.isPaperGlueWt) {
            this.setState({
                isPaperGlue: nextProps.isPaperGlueWt
            }, function () {
                this.calculateFilter();
            });
        }

        this.assignData(nextProps);
    }

    /**
     * toggleCarbonCheck function toggles between checked and unchecked state of carbon checkbox
     *
     * @memberof SingleFilter
     */
    toggleCarbonCheck = () => {
        this.setState({
            isCload: !this.state.isCload,
            isCarbonRange: !this.state.isCload ? false : this.state.isCarbonRange,
            isCapsuleChecked: false
        }, () => {
            this.toggleDisplayForCarbon();
        });
    }

    /**
  *
  * toggleEPDCarbon enables the input field of max carbon load
  * @memberof TowItemSelectionForm
  */
    toggleEPDCarbon() {
        this.setState({ isEPDCarbon: !this.state.isEPDCarbon }, function () {
        });
    }

    /**
     * @function toggleCapsuleCheck function toggles the carbon checkbox
     * @memberof SingleFilter
     */
    toggleCapsuleCheck = () => {
        this.setState({
            isCapsuleChecked: !this.state.isCapsuleChecked,
            isCload: false
        }, () => {
            this.toggleDisplayForCapsule();
        });
    }

    /**
     * toggleRangeCheck function toggles between checked and unchecked state of range checkbox
     *
     * @memberof SingleFilter
     */
    toggleRangeCheck = () => {
        this.setState({ isRangeLength: !this.state.isRangeLength });
    }

    /**
     * toggleCarbonRangeCheck function toggles between checked and unchecked state of carbon range checkbox
     *
     * @memberof SingleFilter
     */
    toggleCarbonRangeCheck = () => {
        if (!this.state.isCload) {
            return false;
        }
        this.setState({ isCRangeLength: !this.state.isCRangeLength });
    }

    /**
     * toggleDisplayForCarbon function toggles between showing and hiding carbon related elements
     *
     * @memberof SingleFilter
     */
    toggleDisplayForCarbon = () => {
        if (this.state.isCload) {
            this.setState({
                carbonDisplay: 'displayBlock',
                capsuleDisplay: 'displayNone'
            });
        }
        else {
            this.setState({
                carbonDisplay: 'displayNone'
            });
        }
    }

    /**
     *  toggleDisplayForCapsule function toggle the carbon Display
     *
     * @memberof SingleFilter
     */
    toggleDisplayForCapsule() {
        if (this.state.isCapsuleChecked) {
            this.setState({
                capsuleDisplay: 'displayBlock',
                carbonDisplay: 'displayNone'
            });
        }
        else {
            this.setState({
                capsuleDisplay: 'displayNone'
            });
        }
    }

    toggleCapsuleMode = (e) => {
        this.setState({
            capsuleMode: e.target.value
        })
    }

    /**
     * checkIsValid function checks whether the field values are valid
     *
     * @memberof SingleFilter
     */
    checkIsValid() {
        return (this.state.name) &&
            (this.state.tipLength && this.state.tipEpd && this.state.plugwrapThickness && (this.state.tipCircumference || this.state.tipDiam)) &&
            (this.state.isNewTowitem ? (this.state.newDpf && this.state.newTd) : (this.state.towItem && this.state.towItem.itemLot));
    }

    towItemDelete(e) {
        e.preventDefault();
        const that = this;

        Modal.confirm({
            title: utils.getTranslationText('msg_delete_tow_item', 'Are you sure delete this tow item?'),
            content: utils.getTranslationText('msg_do_u_wnt_delete_tow_item', 'Do you want to delete the tow item'),
            okText: utils.getTranslationText('lbl_yes', 'Yes'),
            okType: 'danger',
            cancelText: utils.getTranslationText('lbl_no', 'No'),
            onOk() {
                that.setState({
                    towItem: {}
                });
            },
            onCancel() {

            },
        });
    }

    toggleTime = (e) => {
        this.setState({
            isIntermediate: e.target.checked
        });
    }

    /**
     * handleChange function keeps the state value updated to the current value being typed by the user in the form field
     * @param {*} e here e is an event passed
     * @memberof SingleFilter
     */
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    /**
     * handlePlugwrapCancel function closes the plugwrap window
     *
     * @memberof SingleFilter
     */
    handlePlugwrapCancel = () => {
        this.setState({
            isPlugwrapVisible: false
        });
    }

    /**
     * showPlugwrapModal function shows the plugwrap window
     *
     * @memberof SingleFilter
     */
    showPlugwrapModal = () => {
        this.setState({
            isPlugwrapVisible: true
        });
    }

    /**
     * handleTowItemSelectionCancel function closes the tow item selection form window
     *
     * @memberof SingleFilter
     */
    handleTowItemSelectionCancel = () => {
        this.setState({
            isTowItemSelectionVisible: false
        });
    }

    /**
     * showTowItemSelectionModal function opens the tow item selection form window
     * @param {*} e here e is an event passed
     * @memberof SingleFilter
     */
    showTowItemSelectionModal = (e) => {
        e.preventDefault();

        let towItemProps = {
            length: this.state.tipLength * this.state.tipsRod,
            circumference: this.state.tipCircumference,
            diameter: this.state.tipDiam,
            towRange: this.state.isTowRange ? this.state.rangeLength : 0,
            isTowRange: this.state.isTowRange,
            dpfFrom: 0,
            dpfTo: 20,
            dpf: this.state.newDpf,
            td: this.state.newTd,
            pressureDrop: this.state.tipEpd * this.state.tipsRod,
            plugwrapThicknessVal: this.state.plugwrapThickness,
            plasticizer: this.state.pzLevel,
            isCarbonChecked: this.state.isCload,
            isCarbonRange: this.state.isCarbonRange,
            carbonRange: this.state.cRangeLength,
            carbonLoading: this.state.cload,
            isNewTowItemChecked: this.state.isNewTowitem,
            pgWeight: this.state.tipPgWt,
            isPaperGlue: this.state.isPaperGlue
        };

        this.setState({
            isTowItemSelectionVisible: true,
            towItemProps: towItemProps
        });
    }

    /**
     * toggleNewTowItemCheck function toggles between
     * @param {*} e here e is an event passed
     * @memberof SingleFilter
     */
    toggleNewTowItemCheck = (val) => {
        this.setState({
            isNewTowitem: (typeof val === 'boolean') ? val : (val.target ? val.target.value : false)
        });
    }

    /**
     * handleCircChange function sets the diameter value depending upon the circumference value
     * @param {*} e here e is an event passed
     * @memberof SingleFilter
     */
    handleCircChange(e) {
        this.setState({
            tipDiam: Convert.toDiameter(e.target.value)
        });
    }

    /**
     * handleDiaChange function sets the circumference value depending upon the diameter value
     * @param {*} e here e is an event passed
     * @memberof SingleFilter
     */
    handleDiaChange(e) {
        this.setState({
            tipCircumference: Convert.toCircumference(e.target.value)
        });
    }

    convertToCelaneseValues(input) {
        var userPrefs = this.state.preferences;

        //Pascals to MMH2O
        if (parseInt(userPrefs.lowpdlim, 10) === 2) {
            input.rodepd = Convert.toMMH2O(input.rodepd);
            input.tipepd = Convert.toMMH2O(input.tipepd);
        }

        if (parseInt(userPrefs.size, 10) === 2) {
            input.tipcirc = Convert.toCircumference(input.tipcirc);
        }

        switch (parseInt(userPrefs.weight, 10)) {
            case 3:
                input.usrange = Convert.fromGtoG100(input.usrange);
                input.rodpgwt = Convert.fromGtoG100(input.rodpgwt);
                break;
            case 2:
                input.usrange = Convert.fromMGtoG100(input.usrange);
                input.rodpgwt = Convert.fromMGtoG100(input.rodpgwt);
                break
            default:
            // do nothing
        }

        if (parseInt(userPrefs.pz, 10) === 2) {
            input.pz = Convert.toDryBasis(input.pz);
        }

        return input;
    }

    doTowItemCalculations() {
        var newTowItem = {};

        var tipsPerRod = parseFloat(this.state.tipsRod)
        var towItems = [];

        var preferences = Object.assign({}, this.state.preferences);

        if (this.state.towItem && this.state.towItem.itemLot) {
            towItems.push(this.getTowItemByLot(this.state.towItem.itemLot));
        }


        var input = {
            tipsPerRod: tipsPerRod,
            tiplen: parseFloat(this.state.tipLength),
            rodlen: parseFloat(this.state.tipLength) * tipsPerRod,
            tipcirc: parseFloat(this.state.tipCircumference), //cirumference
            tipepd: parseFloat(this.state.tipEpd),
            rodepd: parseFloat(this.state.tipEpd) * tipsPerRod,
            pz: parseFloat(this.state.pzLevel),
            pwthick: parseFloat(this.state.plugwrapThickness),
            newTowItem: this.state.isNewTowitem
        }

        if (preferences.size === 1) {
            input.tipcirc = parseFloat(this.state.tipCircumference) || 0;
        } else {
            input.tipcirc = parseFloat(this.state.tipDiam) || 0;
        }

        if (input.newTowItem) {
            input.dpf = parseFloat(this.state.newDpf) || 0;
            input.td = parseFloat(this.state.newTd) || 0;
            input.ndpf = parseFloat(this.state.newDpf) || 0;
        }

        if (this.state.isCapsuleChecked) {
            let capsWt, capsPD;
            //per capsule
            if (this.state.capsuleMode === "1") {
                capsWt = this.state.capsuleWt * this.state.capsuleNo / input.rodlen;
                capsPD = this.state.capsulePd * this.state.capsuleNo / input.rodlen;
            }
            // per filter rod
            else {
                capsWt = this.state.capsuleWt / input.rodlen;
                capsPD = this.state.capsulePd / input.rodlen;
            }
            input.cload = capsWt;
            input.epdCarbon = capsPD;
        }

        if (this.state.isPaperGlue) {
            input.rodpgwt = parseFloat(this.state.tipPgWt) || 0;
            preferences.pivmaxlim = 2;
        }

        if (this.state.isTowRange) {
            input.usrange = parseFloat(this.state.rangeLength) || 0;
        }

        input.usrRangeLenEnabled = this.state.isTowRange;
        input.carbRangeLenEnabled = this.state.isCload && this.state.isCarbonRange;


        if (this.state.isCload) {
            input.uscrange = parseFloat(this.state.cRangeLength) || 0;
            input.cload = parseFloat(this.state.cload) || 0;
            input.epdCarbon = parseFloat(this.state.epdCarbon) || 0;
        }

        var calculations = Calculations(preferences);

        if (input.newTowItem) {
            newTowItem = Object.assign({}, input);
            newTowItem = calculations.newTowItem(newTowItem);
            towItems.unshift(newTowItem);
        }

        calculations.EPDBiasCorrection(input);

        input = this.convertToCelaneseValues(input);

        for (var key in towItems) {
            var final = Object.assign({}, input, towItems[key]);
            final.ndpf = final.lotadpf;

            if (final.itmcirc) {
                final.stdcirc = final.itmcirc
            }

            if (final.stdpwth) {
                final.stdthick = final.stdpwth
            }

            if (!final.isNew) {
                calculations.slopeAndIntercept(final);
                calculations.minPtAdjustmentByPlant(final);
            }

            calculations.yieldPredictionModel(final);
            calculations.rangeExtension(final);
            calculations.predictPDIncreaseByPZ(final);

            if (final.cload) {
                calculations.predictCarbonCapabilities(final);
                calculations.predictCarbonCapabilityLoad(final);
                if (this.state.isEPDCarbon || this.state.isCapsuleChecked) {
                    calculations.predictCarbonCapabilityLoadManual(final);
                }
                calculations.predictMaxCarbonLoading(final);
            }

            if (
                (final.lotpir < 0 || final.lotpir > 100) ||
                (final.cload > 0 && (final.Cmodel_pir < 0 || final.Cmodel_pir > 100)) ||
                ((final.ndpf < 5 && final.lotatd > 30000 && final.tipcirc < 19) || (final.ndpf > 6 && final.lotatd < 20000 && final.tipcirc > 21))
            ) {
                message.error(utils.getTranslationText('msg_error_pressure_drop', 'Pressure drop target cannot be achieved by this tow item'));
                this.setState({
                    showCalculateBlock: false
                })
                if (this.props.afterCalculate) {
                    this.props.afterCalculate(this.calculatePerTip(final));
                }
                return;
            }

            calculations.targetPD(final);

            calculations.removalEfficienciesCalc(final);

            calculations.firmness(final);
            calculations.firmnessCured(final);
            //calculations.firmnessIntermediate(final, 2);

            if (preferences.pivmaxlim === 2) {
                calculations.adjustWeightToWetWeight(final);
            }


            if (this.state.time) {
                this.handleTimeChange({
                    target: this.state.time
                });
            }

            calculations.AdjDepPresDrop(final);
            calculations.EPDBiasCorrectionsRevert(final);

            this.createTowItemGraph(final);
            this.getDataforFirmnessGraph(calculations, final);


            if (preferences.lowpdlim === 2) {
                final.rodepd = Convert.toPascals(final.rodepd);
            }

            //additional calculated fields
            final.drywt = final.towowt + final.rodpgwt;
            final.pzpd = final.gphtgtpd - final.tgtpd;
            final.CarbonRodWt = final.Cmodel_tgtWgt - final.gphtgtwt;
            final.CarbonRodEPD = final.Cmodel_tgtEPD - final.gphtgtpd;

            if (final.cload === 0) {
                final.CarbonRodWt = 0;
                final.CarbonRodEPD = 0;
                final.filterwt = final.gphtgtwt;
                final.filterpd = final.gphtgtpd;
            } else {
                final.filterwt = final.Cmodel_tgtWgt;
                final.filterpd = final.Cmodel_tgtEPD;
            }

            if (this.state.isCapsuleChecked) {
                final.CapsuleRodWt = final.CarbonRodWt;
                final.CapsuleRodEPD = final.CarbonRodEPD;
                final.CarbonRodWt = 0;
                final.CarbonRodEPD = 0;
            } else {
                final.CapsuleRodWt = 0;
                final.CapsuleRodEPD = 0;
            }

            this.setState({
                finalTowItem: final,
                showCalculateBlock: true,
                rangeLength: (!this.state.isTowRange) ? parseFloat(final.range_ext.toFixed(2)) : this.state.rangeLength,
                cRangeLength: (this.state.isCload && !this.state.isCarbonRange) ? parseFloat(final.Cmodel_range_ext.toFixed(2)) : this.state.cRangeLength
            }, () => {
                this.calculateFirmnessIntermediateByTime(this.state.time);
            });



            if (this.props.afterCalculate) {
                this.props.afterCalculate(this.calculatePerTip(final));
            }



        }
        this.setState({
            isFetchingFilters: false
        });
    }

    calculatePerTip(data) {
        let final = {};
        let tipLen = parseFloat(this.state.tipLength);
        final.filterId = this.state.id;
        final.name = this.state.name;
        final.tiplen = tipLen;
        final.pz = this.state.pzLevel;
        final.tipsrod = parseInt(this.state.tipsRod, 10);
        final.ndpf = data.ndpf;
        final.tipwt = this.perTip(this.state.isCload ? data.Cmodel_tgtWgt : data.gphtgtwt);
        final.tipepd = data.tipepd;
        final.plugwrapThickness = data.pwthick;
        final.tipcirc = data.tipcirc;
        final.hasCload = this.state.isCload;
        final.hasCapsule = this.state.isCapsuleChecked;
        final.towowt = data.towowt;
        final.rodpgwt = data.rodpgwt;
        final.towItem = this.state.towItem;
        final.newDpf = this.state.newDpf;
        final.newTd = this.state.newTd;
        final.isNewTowitem = this.state.isNewTowitem;
        final.tiptowowt = this.perTip(data.towowt);
        final.tiptgtwt = this.perTip(data.gphtgtwt);
        final.tiptgtpd = this.perTip(data.tgtpd);
        final.tippzwt = this.perTip(data.pzwt);
        final.tiprodpgwt = this.perTip(data.rodpgwt);
        final.drywt = final.towowt + final.rodpgwt;
        final.tipdrywt = final.tiptowowt + final.tiprodpgwt;
        final.tippzpd = this.perTip(data.pzpd);
        final.tipgphtgtwt = this.perTip(data.gphtgtwt);
        final.tipgphtgtpd = this.perTip(data.gphtgtpd);

        final.isPaperGlue = this.state.isPaperGlue;


        if (this.state.isCload) {
            final.tipCarbontgtwt = this.perTip(data.Cmodel_tgtWgt - data.gphtgtwt) || 0;
            final.tipCarbontgtpd = this.perTip(data.Cmodel_tgtEPD - data.gphtgtpd) || 0;
            final.filterwt = final.gphtgtwt;
            final.filterpd = final.gphtgtpd;
        } else {
            final.tipCarbontgtwt = 0;
            final.tipCarbontgtpd = 0;
        }

        if (this.state.isCapsuleChecked) {
            final.tipCapsuletgtwt = this.perTip(data.Cmodel_tgtWgt - data.gphtgtwt) || 0;
            final.tipCapsuletgtpd = this.perTip(data.Cmodel_tgtEPD - data.gphtgtpd) || 0;
            final.tipwt += final.tipCapsuletgtwt;
        } else {
            final.tipCapsuletgtwt = 0;
            final.tipCapsuletgtpd = 0;
        }

        final.tipfilterwt = this.perTip(data.filterwt);
        final.tipfilterpd = this.perTip(data.filterpd);


        final.sre = parseFloat(parseFloat(data.sre).toFixed(2)) || 0;
        final.tre = parseFloat(parseFloat(data.tre).toFixed(2)) || 0;
        final.nre = parseFloat(parseFloat(data.nre).toFixed(2)) || 0;
        final.ere = parseFloat(parseFloat(data.ere).toFixed(2)) || 0;

        this.setState({
            newCalculatedData: final
        });

        return final;
    }

    getDataforFirmnessGraph(CalculationFn, input) {
        let data = Object.assign({}, input);

        let graphKeys = ['0', '0.05', '0.0833', '0.1667', '0.25', '0.333', '0.5', '0.75', '1', '1.5', '2'];

        let graphData = []

        graphKeys.map(key => {
            CalculationFn.firmnessIntermediate(data, key);
            graphData.push({
                time: key,
                value: data.firmnessIntermediate || 0
            })

            return true;
        });

        this.setState({
            firmnessData: graphData
        });

    }

    calculateFirmnessIntermediateByTime = (val) => {
        if (val === 0) {
            this.setState({
                firmnessTimeVal: {},
                firmnessIntermediate: 0
            })
            return;
        }
        var calculations = Calculations(this.state.preferences);
        var obj = Object.assign({}, this.state.finalTowItem);
        calculations.firmnessIntermediate(obj, val);
        this.setState({
            firmnessTimeVal: {
                time: val,
                value: obj.firmnessIntermediate
            },
            firmnessIntermediate: obj.firmnessIntermediate
        })
    }

    handleTimeChange(event) {
        let val = event.target.value;
        this.calculateFirmnessIntermediateByTime(val);
    }

    round5(x, isFloor) {
        if (x < 1) {
            return x;
        }
        return isFloor ? Math.floor(x / 5) * 5 : Math.ceil(x / 5) * 5;
    }

    round50(x, isFloor) {
        return isFloor ? Math.floor(x / 50) * 50 : Math.ceil(x / 50) * 50;
    }

    createTowItemGraph(input) {
        var lines = [];
        var minwt = 1000;
        var maxwt = 0;
        var minpd = 1000;
        var maxpd = 0;
        var wtPad = 0;
        var pdPad = 0;
        var wtPref = this.state.preferences.weight;
        var pdPref = this.state.preferences.lowpdlim;

        switch (wtPref) {
            case 2:
                wtPad = 50;
                break;
            case 3:
                wtPad = 0.05;
                break;
            default:
                wtPad = 5
        }

        switch (pdPref) {
            case 2:
                pdPad = 500;
                break;
            default:
                pdPad = 50
        }


        if (input.cload) {
            lines.push({
                color: '#B35751',
                lineData: [
                    {
                        x: parseFloat(input.gphminwt).toFixed(2),
                        y: parseFloat(input.gphminpd).toFixed(2)
                    },
                    {
                        x: parseFloat(input.gphmaxwt).toFixed(2),
                        y: parseFloat(input.gphmaxpd).toFixed(2)
                    }
                ]
            });

            //Carbon
            lines.push({
                color: '#4472C4',
                lineData: [
                    {
                        x: parseFloat(input.Cmodel_tgtC_minwt).toFixed(2),
                        y: parseFloat(input.Cmodel_tgtC_minEPD).toFixed(2)
                    },
                    {
                        x: parseFloat(input.Cmodel_tgtC_maxwt).toFixed(2),
                        y: parseFloat(input.Cmodel_tgtC_maxEPD).toFixed(2)
                    }
                ]
            });

            //target
            lines.push({
                color: '#79a44c',
                lineData: [
                    {
                        x: parseFloat(input.gphtgtwt).toFixed(2),
                        y: parseFloat(input.gphtgtpd).toFixed(2)
                    },
                    {
                        x: parseFloat(input.Cmodel_tgtWgt).toFixed(2),
                        y: parseFloat(input.Cmodel_tgtEPD).toFixed(2)
                    }
                ]
            });

            minwt = lines[0].lineData[0].x;
            maxwt = lines[0].lineData[1].x;
            minpd = lines[0].lineData[0].y;
            maxpd = lines[0].lineData[1].y;

            lines.map(item => {
                let ldata = item.lineData;
                minwt = Math.min(minwt, ldata[0].x);
                maxwt = Math.max(maxwt, ldata[1].x);
                minpd = Math.min(minpd, ldata[0].y);
                maxpd = Math.max(maxpd, ldata[1].y);

                return true;
            })

            this.setState({
                lines: lines,
                gminwt: this.round5(minwt, true) - wtPad,
                gmaxwt: this.round5(maxwt) + wtPad,
                gminpd: this.round50(minpd, true) - pdPad,
                gmaxpd: this.round50(maxpd) + pdPad
            });

        } else {

            minwt = Math.min(minwt, parseFloat(input.gphminwt));
            maxwt = Math.max(maxwt, parseFloat(input.gphmaxwt));
            minpd = Math.min(minpd, parseFloat(input.gphminpd));
            maxpd = Math.max(maxpd, parseFloat(input.gphmaxpd));

            lines.push({
                color: '#B35751',
                target: {
                    x: parseFloat(input.gphtgtwt).toFixed(2),
                    y: parseFloat(input.gphtgtpd).toFixed(2)
                },
                lineData: [
                    {
                        x: parseFloat(input.gphminwt).toFixed(2),
                        y: parseFloat(input.gphminpd).toFixed(2)
                    },
                    {
                        x: parseFloat(input.gphmaxwt).toFixed(2),
                        y: parseFloat(input.gphmaxpd).toFixed(2)
                    }
                ]
            });


            this.setState({
                lines: lines,
                gminwt: this.round5(minwt, true) - wtPad,
                gmaxwt: this.round5(maxwt) + wtPad,
                gminpd: this.round50(minpd, true) - pdPad,
                gmaxpd: this.round50(maxpd) + pdPad
            });

        }
    }

    perTip(val) {
        return parseFloat(parseFloat(val / this.state.tipsRod).toFixed(2));
    }

    convertToUserPreferredValues = (dataObj) => {
        var preferences = this.state.preferences;
        var obj = Object.assign({}, dataObj);
        preferences.weight = parseInt(preferences.weight, 10);
        preferences.lowpdlim = parseInt(preferences.lowpdlim, 10);
        preferences.pz = parseInt(preferences.pz, 10);
        obj.errorFilterChange = false;

        obj.tipDiam = Convert.toDiameter(obj.tipCircumference);
        obj.rangeLength = parseFloat(obj.tipUsRange);
        obj.cRangeLength = parseFloat(obj.tipUscRange);
        obj.isTowRange = parseFloat(obj.tipUsRange) > 0;
        obj.isCarbonRange = parseFloat(obj.tipUscRange) > 0;

        obj.isPaperGlue = this.props.isPaperGlueWt;
        obj.isCapsuleChecked = obj.isCapsule ? obj.isCapsule : false;
        obj.capsuleMode = obj.capsuleMode ? String(obj.capsuleMode) : '0';
        obj.carbonDisplay = obj.isCload ? 'displayBlock' : 'displayNone';
        obj.capsuleDisplay = obj.isCapsuleChecked ? 'displayBlock' : 'displayNone';
        obj.isEPDCarbon = obj.isEPDCarbon ? obj.isEPDCarbon : false;
        obj.epdCarbon = obj.epdCarbon ? obj.epdCarbon : '0';

        if (preferences.lowpdlim === 2) {
            obj.tipEpd = Convert.toPascals(obj.tipEpd);
        }

        if (obj.tipPgWt) {
            if (preferences.weight === 2) {
                obj.tipPgWt = Convert.fromG100toMG(obj.tipPgWt);
            } else if (preferences.weight === 3) {
                obj.tipPgWt = Convert.fromG100toG(obj.tipPgWt);
            }
        }

        if (preferences.pz === 2) {
            obj.pzLevel = Convert.toWetBasis(obj.pzLevel);
        }

        if (obj.isTowRange) {
            if (preferences.weight === 2) {
                obj.rangeLength = Convert.fromG100toMG(obj.rangeLength);
            } else if (preferences.weight === 3) {
                obj.rangeLength = Convert.fromG100toG(obj.rangeLength);
            }
        }

        if (typeof obj.isCapsule === 'boolean') {
            delete obj.isCapsule;
        }
        this.setState({ ...obj }, function () {
            this.calculateUserRange();
            this.calculateFilter();
        });
    }

    handleFilter = () => {
        let data = this.state.filterData;
        let result = data.find(element => element.id === this.state.id);
        if (result) {
            this.setState({
                capsuleMode: "0",
                capsuleWt: 0,
                capsulePd: 0,
                capsuleNo: 0
            });
            this.convertToUserPreferredValues(result);
        } else {
            this.setState({
                id: null,
                filterId: null
            }, function () {
                if (this.state.errorFilterChange) {
                    this.setState({
                        errorFilterChange: false,
                        ...initialState
                    });
                    message.error((this.props.isDualFilter ? `${utils.getTranslationText('msg_segment_b', 'Segment B')}` : `${utils.getTranslationText('msg_segment_a', 'Segment A')}`) + `${utils.getTranslationText('msg_filter_design_deleted', 'Filter design may have been deleted')}`);
                    if (this.props.afterCalculate) {
                        this.props.afterCalculate({
                            'deleted': 'deleted',
                            'rand': Math.random(),
                            id: null,
                            filterId: null,
                            name: ''
                        });
                    }
                } else {
                    this.calculateFilter();
                }
            });
        }
    }

    success = (msg) => {
        msg && message.success(msg, 2);
    };

    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    };

    warning = (msg) => {
        message.warning(msg || utils.getTranslationText('msg_fields_empty', 'The Required fields are empty'), 2);
    };
    saveFilter = (e) => {
        e && e.preventDefault();
        let preferences = this.state.preferences;
        preferences.weight = parseInt(preferences.weight, 10);
        preferences.lowpdlim = parseInt(preferences.lowpdlim, 10);
        preferences.pz = parseInt(preferences.pz, 10);

        if (!this.checkIsValid()) {
            //if save button is clicked show warning
            if (e) {
                if (!this.state.isNewTowitem && this.state.towItem && !this.state.towItem.itemLot) {
                    this.warning(<Translation labelName="msg_no_tow_item_as_selected" defaultText="No tow item has been selected" />);
                } else {
                    this.warning();
                }
            }
            return;
        }

        let dataObj = {
            name: this.state.name.replace(/ \((Shared).*/, ''),
            tipLength: parseFloat(this.state.tipLength),
            tipEpd: parseFloat(this.state.tipEpd),
            tipsRod: parseFloat(this.state.tipsRod),
            pzLevel: parseFloat(this.state.pzLevel),
            cload: parseFloat(this.state.isCload ? this.state.cload : 0),
            tipCircumference: parseFloat(this.state.tipCircumference),
            tipUsRange: parseFloat(this.state.isTowRange ? this.state.rangeLength : 0),
            tipDiam: parseFloat(this.state.tipDiam),
            tipUscRange: parseFloat(this.state.isCarbonRange ? this.state.cRangeLength : 0),
            towItem: {},
            plugwrapThickness: parseFloat(this.state.plugwrapThickness),
            tipPgWt: parseFloat(this.state.tipPgWt),
            newDpf: parseFloat(this.state.newDpf),
            newTd: parseFloat(this.state.newTd),
            time: parseFloat(this.state.time),
            isNewTowitem: this.state.isNewTowitem,
            epdCarbon: parseFloat(this.state.epdCarbon),
            isEPDCarbon: this.state.isEPDCarbon,
            isCload: this.state.isCload,
            isPaperGlue: this.state.isPaperGlue,
            isCapsule: typeof this.state.isCapsuleChecked === 'boolean' ? this.state.isCapsuleChecked : false,
            capsuleMode: this.state.capsuleMode ? Number(this.state.capsuleMode) : 0,
            capsuleWt: parseFloat(this.state.capsuleWt ? this.state.capsuleWt : 0),
            capsulePd: parseFloat(this.state.capsulePd ? this.state.capsulePd : 0),
            capsuleNo: parseFloat(this.state.capsuleNo ? this.state.capsuleNo : 0)
        };

        if (!this.state.isNewTowitem) {
            dataObj.towItem = {
                itemLot: this.state.towItem.itemLot
            }
        }

        // Convert to Celanese values

        if (preferences.lowpdlim !== 1) {
            dataObj.tipEpd = Convert.toMMH2O(dataObj.tipEpd);
        }

        if (dataObj.tipPgWt) {
            if (preferences.weight === 2) {
                dataObj.tipPgWt = Convert.fromMGtoG100(dataObj.tipPgWt);
                dataObj.tipUsRange = this.state.isTowRange ? Convert.fromMGtoG100(dataObj.tipUsRange) : 0;
            } else if (preferences.weight === 3) {
                dataObj.tipPgWt = Convert.fromGtoG100(dataObj.tipPgWt);
                dataObj.tipUsRange = this.state.isTowRange ? Convert.fromGtoG100(dataObj.tipUsRange) : 0;
            }
        }

        if (preferences.pz === 2) {
            dataObj.pzLevel = Convert.toDryBasis(dataObj.pzLevel);
        }

        if (dataObj.name) {
            this.setState({
                loading: true
            }, function () {
                let promiseObj;
                if (this.state.id) {
                    promiseObj = CelaneseAPI.patch(config.API.filters + '/' + this.state.id, dataObj);
                } else {
                    promiseObj = CelaneseAPI.post(config.API.filters, dataObj);
                }
                promiseObj.then(res => {
                    if (res.data) {
                        let data = res.data instanceof Array ? res.data[0] : res.data;

                        if (e) {
                            if (this.state.id) {
                                this.success(utils.getTranslationText('msg_filter_updated_success', "Filter '${name}' is Updated Successfully").replace('${name}', this.state.name));
                            } else {
                                this.success(utils.getTranslationText('msg_new_filter_created_success', "New Filter '${name}' is created Successfully").replace('${name}', this.state.name));
                            }
                        }
                        this.setState({
                            loading: false,
                            id: data.id
                        }, function () {
                            // this.props.updateFilterData(this.state.filterData);
                            getFiltersData().then(res => {
                                return res;
                            });
                            this.calculateFilter();
                        });
                    }
                }).catch(() => {
                    this.setState({
                        loading: false
                    });
                    this.error();
                });
            });
        } else {
            this.warning();
        }
    }
    calculateFilter = (e) => {
        if (e) {
            e.preventDefault();
            if (!this.state.isNewTowitem && this.state.towItem && !this.state.towItem.itemLot) {
                this.warning(utils.getTranslationText('msg_no_tow_item_as_selected', 'No tow item has been selected'));
            }
        }
        this.doTowItemCalculations();
    }
    updatePlugwrapValue = (data) => {
        this.setState({
            plugwrapThickness: data
        });
    }
    towItemSelect = (itemLot) => {
        this.setState({
            towItem: {
                itemLot: itemLot
            },
            towItemLot: itemLot
        });
    }
    componentWillMount() {
        this.props.calculate && this.props.calculate(this.calculateFilter);
        this.assignData(this.props);
        const toFilterData = this.props.toFilterTowItemData;
        if (toFilterData && toFilterData.isNewTowItemChecked) {
            this.toggleNewTowItemCheck(toFilterData.isNewTowItemChecked);
        }
    }

    componentDidMount() {
        if (this.state.tipLength) {
            this.calculateFilter();
        }
    }

    assignData = (nextProps) => {
        if (nextProps.itemData) {
            this.setState({
                towItems: nextProps.itemData
            });
        }
        if (nextProps.filtersData && this.state.filterData !== nextProps.filterData) {
            this.setState({
                filterData: nextProps.filtersData
            })
        }
    }

    getTowItemByLot = (itemlot) => {
        return this.state.towItems.find(towItem => {
            return towItem.itemlot === itemlot;
        });
    }

    calculateUserRange = (force) => {
        if (!this.state.isTowRange || force === true) {

            // this.setState({
            //     rangeLength: rangeLen ? rangeLen.toFixed(2) : rangeLen
            // });
        }

    }

    toggleTowRange = () => {
        this.setState({ isTowRange: !this.state.isTowRange }, function () {
        });
        this.calculateUserRange(true);
    }

    toggleCarbonRange = () => {
        this.setState({ isCarbonRange: !this.state.isCarbonRange }, function () {
        });
    }

    render() {
        let numberOfTows = this.state.finalTowItem.tipsPerRod || 0;
        let imageHTML = [];
        for (let i = 0; i < numberOfTows; i++) {
            imageHTML.push(<li key={i}><img alt='filter tip' src={this.props.isDualFilter ? "./images/orange_tip.svg" : "./images/tow.svg"} /><span>{this.props.isDualFilter ? <Translation labelName="lbl_b" defaultText="B" /> : <Translation labelName="lbl_a" defaultText="A" />}</span></li>);
        }
        imageHTML.push(<li key="blank" className='blank'><img alt='filter tip' src={this.props.isDualFilter ? "./images/orange_tip.svg" : "./images/tow.svg"} /></li>);
        let ListItem = ({ item }) => (
            <Fragment>
                {item.name} <i>{" " + item.displayName}</i>
            </Fragment>
        );
        return (
            <div className='filter-wrapper row'>
                <div className='col-md-12'>
                    <div className={this.state.showCalculateBlock ? 'filter-form-container filter-calculate' : 'filter-form-container'}>
                        <div className='row'>
                            <div className='filter-wrapper__field filter-name'>
                                <label><Translation labelName="lbl_name" defaultText="Name" />:<i>{this.state.sharedByName ? this.state.sharedByName : null}</i></label>
                                <Combobox
                                    caseSensitive={false}
                                    busy={this.state.isFetchingFilters}
                                    value={
                                        {
                                            name: this.state.name,
                                            id: this.state.id
                                        }
                                    }
                                    onChange={(obj) => {
                                        let sharedByName = '';

                                        if (typeof obj === 'object' && obj.name && obj.isShared) {
                                            sharedByName = obj.displayName;
                                        } else if (typeof obj === 'string' && obj.length > 30) {
                                            return;
                                        }

                                        this.setState({
                                            name: obj.name || obj,
                                            id: obj.id || null,
                                            sharedByName: sharedByName
                                        }, function () {
                                            this.handleFilter();
                                        })
                                    }
                                    }
                                    data={(this.state.filterData) ? this.state.filterData : []}
                                    messages={{
                                        emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list" />,
                                    }}
                                    textField='name'
                                    valueField='id'
                                    itemComponent={ListItem}
                                />
                            </div>
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_rod_weight_range" defaultText="Rod Weight Range" />}
                                units={' (' + this.state.pref.weight[this.state.preferences.weight - 1] + ')'}
                                name='rangeLength'
                                showCheckBox={true}
                                value={this.state.rangeLength}
                                id='rangeLength'
                                allowedZero={true}
                                disabled={!this.state.isTowRange}
                                onChecked={this.toggleTowRange}
                                onChange={(event) => this.handleChange(event)}
                                className='filter-wrapper__field'
                            />
                        </div>
                        <div className='row'>
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_tip_length" defaultText="Tip Length" />}
                                name='tipLength'
                                units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                value={this.state.tipLength}
                                id='tipLength'
                                min='5'
                                max='31'
                                errorMinMax={<Translation labelName="err_min_max_value_should_be_between_5-31mm" defaultText="value should be between 5 - 31mm" />}
                                onChange={(event) => this.handleChange(event)}
                                className='filter-wrapper__field'
                                onBlur={this.calculateUserRange}
                            />
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_tips_per_rod" defaultText="Tips per Rod" />}
                                name='tipsRod'
                                min='0'
                                allowedZero={true}
                                className='filter-wrapper__field'
                                value={this.state.tipsRod}
                                id='tipsRod'
                                onChange={(event) => this.handleChange(event)}
                                onBlur={this.calculateUserRange}
                            />
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_rod_length" defaultText="Rod Length" />}
                                name='rodlength'
                                units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                value={(this.state.tipLength * this.state.tipsRod).toFixed(0) || 0}
                                id='rodLength'
                                disabled={true}
                                className='filter-wrapper__field'
                            />
                        </div>
                        <div className="row">
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_tip_circumference" defaultText="Tip Circumference" />}
                                name='tipCircumference'
                                units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                value={this.state.tipCircumference}
                                id='tipCircumference'
                                min='14'
                                max='26'
                                disabled={this.state.preferences.size !== 1}
                                errorMinMax={<Translation labelName="err_msg_value_must_be_between_14-26_mm" defaultText="value must be between 14 - 26mm" />}
                                onChange={(event) => this.handleChange(event)}
                                onBlur={(event) => this.handleCircChange(event)}
                                className='filter-wrapper__field'
                            />
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_tip_diameter" defaultText="Tip Diameter" />}
                                name='tipDiam'
                                units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                value={this.state.tipDiam}
                                id='tipDiam'
                                min='4.46'
                                max='8.28'
                                disabled={this.state.preferences.size !== 2}
                                errorMinMax={<Translation labelName="err_msg_value_not_between_4.46-8.28_mm" defaultText="value must be between 4.46 - 8.28mm" />}
                                onChange={(event) => this.handleChange(event)}
                                onBlur={(event) => this.handleDiaChange(event)}
                                className='filter-wrapper__field'
                            />
                            {this.state.isPaperGlue ?
                                <InputField
                                    type='number'
                                    label={<Translation labelName="lbl_rod_paper+Glue_weight" defaultText="Rod Paper+Glue weight" />}
                                    allowedZero={true}
                                    units={' (' + this.state.pref.weight[this.state.preferences.weight - 1] + ')'}
                                    name='tipPgWt'
                                    min='0'
                                    disabled={!this.state.isPaperGlue}
                                    id='tipPgWt'
                                    value={this.state.tipPgWt}
                                    onChange={(event) => this.handleChange(event)}
                                    className='filter-wrapper__field'
                                /> : null}
                        </div>
                        <div className='row'>
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_tip_epd" defaultText="Tip EPD" />}
                                name='tipEpd'
                                allowedZero={true}
                                units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                                value={this.state.tipEpd}
                                id='tipEpd'
                                onChange={(event) => this.handleChange(event)}
                                className='filter-wrapper__field'
                            />
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_rod_epd" defaultText="Rod EPD" />}
                                name='rodEpd'
                                allowedZero={true}
                                units={'(' + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'}
                                value={this.state.tipEpd * this.state.tipsRod}
                                id='rodEpd'
                                disabled={true}
                                className='filter-wrapper__field'
                            />
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_plasticizer" defaultText="Plasticizer" />}
                                name='pzLevel'
                                units={<Fragment>(% <Translation labelName={this.state.pref.pz[this.state.preferences.pz - 1] && this.state.pref.pz[this.state.preferences.pz - 1].split(' ').join('').toLowerCase().indexOf('drybasis') >= 0 ? 'lbl_dry_basis' : 'lbl_wet_basis'} defaultText={this.state.pref.pz[this.state.preferences.pz - 1]} />)</Fragment>}
                                errorMinMax={<Translation labelName="err_msg_min_max_value_cannot_be_greater_than_10" defaultText="value cannot be greater than 10" />}
                                value={this.state.pzLevel}
                                id='pzLevel'
                                allowedZero={true}
                                onChange={(event) => this.handleChange(event)}
                                className='filter-wrapper__field'
                            />
                            <InputField
                                type='number'
                                label={<Translation labelName="lbl_plugwrap_thickness" defaultText="Plugwrap Thickness" />}
                                units={<Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>}
                                id='plugwrapThickness'
                                min='0'
                                buttonIcon='setting'
                                onButtonClick={this.showPlugwrapModal}
                                name='plugwrapThickness'
                                className='filter-wrapper__field plugwrap'
                                value={this.state.plugwrapThickness}
                                onChange={(event) => this.handleChange(event)}
                            />
                        </div>
                        <div className="carbon-capsule-container">
                            <div className="carbon-container">
                                <div>
                                    <h4><Switch
                                        size="small"
                                        checked={this.state.isCload}
                                        onChange={this.toggleCarbonCheck}
                                    />&nbsp;&nbsp; {<Translation labelName="opt_carbon_properties" defaultText="Carbon Properties" />}</h4>
                                    <div className={this.state.carbonDisplay}>
                                        <InputField
                                            type='number'
                                            label={<Translation labelName="lbl_load" defaultText="Load" />}
                                            showCheckBox={false}
                                            units={<Fragment>(<Translation labelName="units_mg_mm" defaultText="mg/mm" />)</Fragment>}
                                            onChecked={this.toggleCarbonCheck}
                                            disabled={!this.state.isCload}
                                            name='cload'
                                            id='cload'
                                            allowedZero={true}
                                            min='0'
                                            value={this.state.isCload ? this.state.cload : 0}
                                            onChange={(event) => this.handleChange(event)}
                                            className='carbon-field filter-wrapper__field'
                                        />
                                        <div disabled={!this.state.isCload} className="max-carbon-wrapper">
                                            <InputField
                                                type="number"
                                                label={<Translation labelName="lbl_pd_carbon" defaultText="PD Due to carbon" />}
                                                name="epdCarbon"
                                                units={this.state.pref.lowpdCarbonlim[this.state.preferences.lowpdlim - 1]}
                                                min='0'
                                                showCheckBox={true}
                                                onChecked={this.toggleEPDCarbon}
                                                disabled={!this.state.isEPDCarbon}
                                                id="epdCarbon"
                                                value={this.state.epdCarbon}
                                                onChange={(event) => this.handleChange(event)}
                                                className="normal-wrap filter-wrapper__field"
                                            />
                                            <InputField
                                                type='number'
                                                label={<Translation labelName="lbl_max_carbon_load" defaultText="Max Carbon Load" />}
                                                name='cRangeLength'
                                                units={<Fragment>(<Translation labelName="units_lbl_mg" defaultText="mg" />)</Fragment>}
                                                showCheckBox={true}
                                                value={this.state.cRangeLength}
                                                id='cRangeLength'
                                                compDisabled={!this.state.isCload}
                                                disabled={!this.state.isCload || !this.state.isCarbonRange}
                                                allowedZero={true}
                                                visible={this.state.isCload}
                                                onChecked={this.toggleCarbonRange}
                                                onChange={(event) => this.handleChange(event)}
                                                className='filter-wrapper__field'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div>
                                    <h4><Switch
                                        onChange={this.toggleCapsuleCheck}
                                        checked={this.state.isCapsuleChecked}
                                        size="small"
                                    />&nbsp;&nbsp; <Translation labelName="opt_capsule_properties" defaultText="Capsule Properties" /></h4>
                                </div>
                                <div className={this.state.capsuleDisplay + ' cap-props'}>
                                    <div className="col-md-4">
                                        <Radio.Group size="small" name="capsuleModes" value={this.state.capsuleMode} onChange={(e) => this.toggleCapsuleMode(e)} style={{ marginLeft: '10px' }} buttonStyle="solid">
                                            <Radio value="1"><Translation labelName="lbl_per_capsule" defaultText="Per Capsule" /></Radio>
                                            <Radio value="0"><Translation labelName="lbl_capsules_filter_rod" defaultText="All Capsules in Filter Rod" /></Radio>
                                        </Radio.Group>
                                    </div>
                                    <div className="col-md-8">
                                        <InputField
                                            type="number"
                                            label={<Translation labelName="lbl_capsule_weight" defaultText="Capsule Weight" />}
                                            name="capsuleWt"
                                            units={this.state.pref.capsule[this.state.capsuleMode].weight}
                                            allowedZero={true}
                                            min='0'
                                            className="properties__form-field col-md-12"
                                            value={this.state.capsuleWt}
                                            id="capsuleWt"
                                            onChange={(event) => this.handleChange(event)}
                                        />
                                        <InputField
                                            type="number"
                                            label={<Translation labelName="lbl_capsule_pd" defaultText="Capsule PD" />}
                                            name="capsulePd"
                                            units={this.state.pref.capsule[this.state.capsuleMode].lowpdlim[this.state.preferences.lowpdlim - 1]}
                                            allowedZero={true}
                                            min='0'
                                            className="properties__form-field col-md-12"
                                            value={this.state.capsulePd}
                                            id="capsulePd"
                                            onChange={(event) => this.handleChange(event)}
                                        />
                                        <InputField
                                            type="number"
                                            label={<Translation labelName="lbl_no_capsule_per_rod" defaultText="No of Capsules per Rod" />}
                                            name="capsuleNo"
                                            allowedZero={true}
                                            min='0'
                                            className="properties__form-field col-md-12"
                                            value={this.state.capsuleNo}
                                            disabled={this.state.capsuleMode === '0'}
                                            id="capsuleNo"
                                            onChange={(event) => this.handleChange(event)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="newtow-container">
                                <Radio.Group size="small" value={this.state.isNewTowitem} onChange={this.toggleNewTowItemCheck} style={{ marginBottom: '10px' }} buttonStyle="solid">
                                    <Radio.Button value={false}><Translation labelName="lbl_commercial-tow_item" defaultText="Commercial tow item" /></Radio.Button>
                                    <Radio.Button value={true}><Translation labelName="lbl_predicted_tow_item" defaultText="Predicted tow item" /></Radio.Button>
                                </Radio.Group>

                                {!this.state.isNewTowitem ? (
                                    <div className='select-new-towitem'>
                                        {(this.state.towItem && this.state.towItem.itemLot) ?
                                            (<div>
                                                <label><Translation labelName="btn_select_tow_Item" defaultText="Selected Tow Item" /></label>
                                                <Tag
                                                    closable
                                                    color="blue"
                                                    onClose={this.towItemDelete}
                                                >{this.state.towItem ? this.state.towItem.itemLot : null}</Tag>
                                            </div>
                                            )
                                            :
                                            (<div>
                                                <label><Translation labelName="lbl_select_a_tow_item" defaultText="Click the following button to select a tow item" /></label>
                                                <a href='#'
                                                    className='btn btn-default select-towitem-link'
                                                    onClick={(e) => this.showTowItemSelectionModal(e)}><Translation labelName="btn_select_tow_Item" defaultText="Select Tow Item" /></a>
                                            </div>
                                            )
                                        }
                                    </div>
                                ) : null}

                                {this.state.isNewTowitem ? (<Fragment>
                                    <InputField
                                        type='number'
                                        label={<Translation labelName="lbl_dpf" defaultText="DPF" />}
                                        name='newDpf'
                                        min='0'
                                        id='newDpf'
                                        value={this.state.newDpf}
                                        onChange={(event) => this.handleChange(event)}
                                        className='filter-wrapper__field'
                                    />
                                    <InputField
                                        type='number'
                                        label={<Translation labelName="lbl_td" defaultText="TD" />}
                                        name='newTd'
                                        min='0'
                                        id='newTd'
                                        value={this.state.newTd}
                                        onChange={(event) => this.handleChange(event)}
                                        className='filter-wrapper__field'
                                    />
                                    <div className="clearfix"></div>
                                    <Alert type="warning" showIcon message={<span><Translation labelName="msg_info_predicted_tow_item_questions_please_contact" defaultText="Predicted tow item. For questions please contact" />
                                        <a href="mailto:towplus.support@celanese.com" ><Translation labelName="msg_info_celanese_global_technical_solutions" defaultText="Celanese Global Technical Solutions" /></a></span>} />
                                </Fragment>) : null}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 filter-wrapper-links'>
                                <Button
                                    className="calculate-link btn btn-primary"
                                    type="primary"
                                    onClick={(e) => this.calculateFilter(e)}
                                    disabled={
                                        !(this.state.tipLength && this.state.tipEpd && this.state.plugwrapThickness && (this.state.tipCircumference || this.state.tipDiam)) &&
                                        (this.state.isNewTowitem ? !(this.state.newDpf && this.state.newTd) : !this.state.towItem)
                                    }
                                >
                                    <Translation labelName="btn_calculate" defaultText="Calculate" />
                                </Button>
                                <Button
                                    className="save-link btn btn-primary"
                                    type="primary"
                                    onClick={(e) => this.saveFilter(e)}
                                    loading={this.state.loading}
                                    disabled={
                                        !(this.state.name) &&
                                        !(this.state.tipLength && this.state.tipEpd && this.state.plugwrapThickness && (this.state.tipCircumference || this.state.tipDiam)) &&
                                        !(this.state.isNewTowitem ? (this.state.newDpf && this.state.newTd) : (this.state.towItem && this.state.towItem.itemLot))
                                    }
                                > <Translation labelName="btn_save" defaultText="Save" /></Button>
                            </div>
                        </div>
                    </div>
                    {this.state.showCalculateBlock ?
                        <div className='filter-tip-design row'>
                            <div className='top-shadow'></div>
                            <div className=''>
                                <table className='filter-tip'>
                                    <tbody>
                                        <tr className='head-row'>
                                            <td>&nbsp;</td>
                                            <td colSpan="2" className='tip-image text-center'>
                                                <ul className='tow-images'>
                                                    {imageHTML}
                                                </ul>
                                                <h4><Translation labelName="lbl_filter_rod" defaultText="Filter Rod" /></h4>
                                            </td>
                                            <td colSpan="2" className='text-center'>
                                                <ul className='tow-images single tip-image'>
                                                    <li><img alt='filter tip' src={this.props.isDualFilter ? "./images/orange_tip.svg" : "./images/tow.svg"} /><span>{this.props.isDualFilter ? <Translation labelName="lbl_b" defaultText="B" /> : <Translation labelName="lbl_a" defaultText="A" />}</span></li>
                                                </ul>
                                                <h4><Translation labelName="lbl_tip" defaultText="Tip" /></h4>
                                            </td>
                                        </tr>
                                        <tr className='top-row'>
                                            <td><label><Translation labelName="lbl_length" defaultText="Length" /> <span><Fragment>(<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment></span></label></td>
                                            <td colSpan="2" className='text-center'><span className='head-val'>{parseInt(this.state.finalTowItem.rodlen, 10)}</span></td>
                                            <td colSpan="2" className='text-center'><span className='head-val'>{parseInt(this.state.finalTowItem.tiplen, 10)}</span></td>
                                        </tr>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Wgt <span className="unit">({this.state.pref.weight[this.state.preferences.weight - 1]})</span></th>
                                            <th>EPD <span className="unit">({this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1]})</span></th>
                                            <th>Wgt <span className="unit">({this.state.pref.weight[this.state.preferences.weight - 1]})</span></th>
                                            <th>EPD <span className="unit">({this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1]})</span></th>
                                        </tr>
                                        <tr>
                                            <td><label>Tow Only</label></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.towowt).toFixed(2)}</span></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.tgtpd).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.towowt).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.tgtpd).toFixed(2)}</span></td>
                                        </tr>
                                        {this.state.finalTowItem.rodpgwt > 0 && <tr>
                                            <td><label>Paper+Glue</label></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.rodpgwt).toFixed(2)}</span></td>
                                            <td><span>0.00</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.rodpgwt)}</span></td>
                                            <td><span>0.00</span></td>
                                        </tr>}
                                        {this.state.finalTowItem.rodpgwt > 0 && <tr className="white-filter">
                                            <td><label>Dry Filter</label></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.drywt).toFixed(2)}</span></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.tgtpd).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.drywt).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.tgtpd).toFixed(2)}</span></td>
                                        </tr>}
                                        {this.state.finalTowItem.pz > 0 && <tr>
                                            <td><label>Pz</label></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.pzwt).toFixed(2)}</span></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.pzpd).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.pzwt).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.pzpd).toFixed(2)}</span></td>
                                        </tr>}
                                        {this.state.finalTowItem.pz > 0 && <tr className="white-filter">
                                            <td><label>Wet Filter</label></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.gphtgtwt).toFixed(2)}</span></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.gphtgtpd).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.gphtgtwt).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.gphtgtpd).toFixed(2)}</span></td>
                                        </tr>}
                                        {this.state.isCload && <tr>
                                            <td><label>Carbon Rod</label></td>
                                            <td><span className='is-carbon'>{parseFloat(this.state.finalTowItem.CarbonRodWt).toFixed(2)}</span></td>
                                            <td><span className='is-carbon'>{parseFloat(this.state.finalTowItem.CarbonRodEPD).toFixed(2)}</span></td>
                                            <td><span className='is-carbon'>{this.perTip(this.state.finalTowItem.CarbonRodWt).toFixed(2)}</span></td>
                                            <td><span className='is-carbon'>{this.perTip(this.state.finalTowItem.CarbonRodEPD).toFixed(2)}</span></td>
                                        </tr>}
                                        {this.state.isCapsuleChecked && <tr>
                                            <td><label>Capsule Rod</label></td>
                                            <td><span className='is-capsule'>{parseFloat(this.state.finalTowItem.CapsuleRodWt).toFixed(2)}</span></td>
                                            <td><span className='is-capsule'>{parseFloat(this.state.finalTowItem.CapsuleRodEPD).toFixed(2)}</span></td>
                                            <td><span className='is-capsule'>{this.perTip(this.state.finalTowItem.CapsuleRodWt).toFixed(2)}</span></td>
                                            <td><span className='is-capsule'>{this.perTip(this.state.finalTowItem.CapsuleRodEPD).toFixed(2)}</span></td>
                                        </tr>}
                                        {(this.state.isCload || this.state.isCapsuleChecked) && <tr className="white-filter">
                                            <td><label>Total Filter</label></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.filterwt).toFixed(2)}</span></td>
                                            <td><span>{parseFloat(this.state.finalTowItem.filterpd).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.filterwt).toFixed(2)}</span></td>
                                            <td><span>{this.perTip(this.state.finalTowItem.filterpd).toFixed(2)}</span></td>
                                        </tr>}
                                    </tbody>
                                </table>
                            </div>
                            <div className="text-center vis-wrap">
                                <CapabilityGraphSmall
                                    lines={this.state.lines}
                                    reload={this.props.reloadGraph}
                                    size={{ height: 270, width: 250 }}
                                    class={this.props.isDualFilter ? 'second-graph' : 'single-filter'}
                                    axis={{
                                        x: {
                                            min: this.state.gminwt,
                                            max: this.state.gmaxwt,
                                            name: (this.state.isPaperGlue ? utils.getTranslationText('lbl_total_weight', 'Total Weight') : utils.getTranslationText('lbl_tow_weight', 'Tow Only Weight')) + ' (' + this.state.pref.weight[this.state.preferences.weight - 1] + ')'
                                            // name: (this.state.isPaperGlue ? <Translation labelName='lbl_tow_weight' defaultText='Tow Only Weight' /> : <Translation labelName='lbl_total_weight' defaultText='Total Weight' />) + ' (' + this.state.pref.weight[this.state.preferences.weight - 1] + ')'
                                        },
                                        y: {
                                            min: this.state.gminpd,
                                            max: this.state.gmaxpd,
                                            name: `${utils.getTranslationText('lbl_epd', 'EPD')} (` + this.state.pref.lowpdlim[this.state.preferences.lowpdlim - 1] + ')'
                                        }
                                    }}
                                />
                                {/* <CustomGraph
                                    lines={this.state.lines}
                                    size={{height: 270, width: 250}}
                                    class={this.props.isDualFilter ? 'second-graph' : 'single-filter'} axis={{
                                        x: {
                                            min: this.state.gminwt,
                                            max: this.state.gmaxwt,
                                            name: 'Tow only Weight ' + this.state.pref.weight[this.state.preferences.weight-1]
                                        },
                                        y: {
                                            min: this.state.gminpd,
                                            max: this.state.gmaxpd,
                                            name:'EPD '+ this.state.pref.lowpdlim[this.state.preferences.lowpdlim-1]
                                        }
                                }}/>    */}
                            </div>
                        </div>
                        : null}
                    {this.state.showCalculateBlock ?
                        <div className='filter-efficiencies-firmware row'>
                            <div className='filter-efficiencies col-md-4'>
                                <h4><Translation labelName="lbl_removal_efficiencies" defaultText="Removal Efficiencies" /></h4>
                                <ul>
                                    <li className="filter-values">
                                        <label><Translation labelName="lbl_smoke" defaultText="Smoke" /></label>
                                        <span>{parseFloat(this.state.finalTowItem.sre).toFixed(2)} <Translation labelName="units_%" defaultText="%" /></span>
                                    </li>
                                    <li>
                                        <label><Translation labelName="lbl_tar" defaultText="Tar" /></label>
                                        <span>{parseFloat(this.state.finalTowItem.tre).toFixed(2)} <Translation labelName="units_%" defaultText="%" /></span>
                                    </li>
                                    <li>
                                        <label><Translation labelName="lbl_nicotine" defaultText="Nicotine" /></label>
                                        <span>{parseFloat(this.state.finalTowItem.nre).toFixed(2)} <Translation labelName="units_%" defaultText="%" /></span>
                                    </li>
                                    <li className={this.state.preferences.kretek ? 'displayBlock' : 'displayNone'}>
                                        <label><Translation labelName="lbl_eugenol" defaultText="Eugenol" /></label>
                                        <span>{parseFloat(this.state.finalTowItem.ere).toFixed(2)} <Translation labelName="units_%" defaultText="%" /></span>
                                    </li>
                                </ul>
                                <h4 className="m2-top"><Translation labelName="lbl_firmness" defaultText="Firmness" />
                                    <strong>&nbsp;({this.state.preferences.firmnessMethod ? this.state.preferences.firmnessMethod : <Translation labelName="txt_filtrona_fts" defaultText="Filtrona FTS" />})</strong>
                                </h4>
                                <ul>
                                    <li>
                                        <label><Translation labelName="lbl_cured_time" defaultText="Cured Time" /></label>
                                        <span>{parseFloat(this.state.finalTowItem.firmness).toFixed(1)} <Translation labelName="units_%" defaultText="%" /></span>
                                    </li>
                                    <li>
                                        <label><Translation labelName="lbl_Intermediate" defaultText="Intermediate" /></label>
                                        <span>{parseFloat(this.state.firmnessIntermediate).toFixed(1)} <Translation labelName="units_%" defaultText="%" /></span>
                                    </li>
                                    {this.state.isIntermediate ? (
                                        <li>
                                            <label><Translation labelName="lbl_time" defaultText="Time" /></label>
                                            <span>
                                                <input
                                                    type='number'
                                                    value={this.state.time}
                                                    name="time"
                                                    id="time"
                                                    min="0"
                                                    max="2"
                                                    onChange={(event) => this.handleChange(event)}
                                                    onBlur={(event) => this.handleTimeChange(event)}
                                                    className='time-input' /> {utils.getTranslationText('lbl_hrs', 'Hrs')}
                                            </span>
                                        </li>
                                    ) : null}
                                </ul>
                            </div>
                            <div className='col-md-8 filter-bottom-graph'>
                                <CustomLineGraph
                                    reload={this.props.reloadGraph}
                                    data={this.state.firmnessData}
                                    width={this.props.isDualFilter ? 400 : 300}
                                    height={300}
                                    highlightPoint={this.state.firmnessTimeVal}
                                    langSwitch={this.state.langSwitch}
                                    assignClass={this.props.isDualFilter ? 'second-graph-firmware' : 'single-filter-firmware'}
                                />
                            </div>
                        </div> : null}
                </div>
                {this.state.isPlugwrapVisible && <Modal
                    visible={this.state.isPlugwrapVisible}
                    footer={null}
                    width='80%'
                    centered
                    style={{ top: 20 }}
                    onCancel={this.handlePlugwrapCancel}>
                    <PlugwrapThickness
                        updatePlugwrapValue={this.updatePlugwrapValue}
                        handlePlugwrapCancel={this.handlePlugwrapCancel}
                        rowSelectionDisable={true}>
                    </PlugwrapThickness>
                </Modal>}
                <Modal
                    visible={this.state.isTowItemSelectionVisible}
                    footer={null}
                    width='95%'
                    centered
                    className="towitemselection-modal"
                    onCancel={this.handleTowItemSelectionCancel}>
                    <TowItemSelectionForm
                        handleTowItemSelectionCancel={this.handleTowItemSelectionCancel}
                        towItemLot={this.state.towItemLot}
                        towItemProps={this.state.towItemProps}
                        towItemSelect={this.towItemSelect}
                        isPropsData={true}>
                    </TowItemSelectionForm>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = ({ loggedUserState, towItemsState, filtersState }) => ({
    preferences: loggedUserState.prefData && loggedUserState.prefData.preferences,
    itemData: towItemsState.itemData,
    filtersData: filtersState.filtersData
});

export default connect(mapStateToProps, null)(SingleFilter);

SingleFilter.propTypes = {
    isPaperGlueWt: PropTypes.bool,
    isDualFilter: PropTypes.bool,
    preferences: PropTypes.object,
    saveFiltersData: PropTypes.string,
    saveFiltersId: PropTypes.string,
    calculate: PropTypes.func,
    afterCalculate: PropTypes.func,
    getFilter: PropTypes.func,
    random: PropTypes.string,
    saveRandomKey: PropTypes.string,
    onChangePaperGlue: PropTypes.func,
    filterData: PropTypes.array,
    itemData: PropTypes.array,
    filtersData: PropTypes.array,
    getFiltersData: PropTypes.func,
    reloadGraph: PropTypes.bool,
    toFilterTowItemData: PropTypes.object,
    toFilterTowItemVal: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/components/FIlters/SingleFilter/index.js